wbApp.directive('wbDueDateTypeCombo', ['$timeout', '$translate',
    function ($timeout, $translate) {
        function formatResult(data) {
            if (!data) { return; }
            return $translate.instant(data.text);
        }

        function formatSelection(data) {
            return $translate.instant(data.text);
        }

        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elm, attrs, controller) {

                $timeout(function () {
                    $(elm).select2({
                        placeholder: $translate.instant('TXT_LBL_DEFAULT_FROM_CENTRAL_SETTING'),
                        formatResult: formatResult,
                        formatSelection: formatSelection,
                        dropdownAutoWidth: true,
                        allowClear: !attrs.required,
                        minimumResultsForSearch: -1,
                        data: [
                            { id: 0, text: 'TXT_VAL_NO_OF_DAYS_AFTER_ISSUE_DATE' },
                            { id: 1, text: 'TXT_VAL_ON_SPECIFIC_DATE' }
                        ]
                    });

                    controller.$render = function () {
                        elm.select2('val', controller.$viewValue);
                    };

                    controller.$parsers.unshift(function (viewValue) {
                        if (String.prototype.isNullOrWhitespace(viewValue)) {
                            return null;
                        } else {
                            return parseInt(viewValue);
                        }
                    });

                    controller.$formatters.unshift(function (value) {
                        if (!typeof value === 'undefined' || value === null) {
                            return value;
                        } else {
                            return value + "";
                        }
                    });

                    elm.on('change', function () {
                        scope.$apply(function () {
                            controller.$setViewValue(elm.select2('val'));
                        });
                    });

                    attrs.$observe('disabled', function (value) {
                        elm.select2('enable', !value);
                    });

                    attrs.$observe('readonly', function (value) {
                        elm.select2('readonly', !!value);
                    });

                    elm.bind("$destroy", function () {
                        elm.select2("destroy");
                    });

                }, 1);
            }
        }
    }]);